import { PageWithLayout } from '@/pages/_app';
import { Navigate, useSearchParams } from 'react-router-dom';

const OrderDetailsOld: PageWithLayout = () => {
    const [searchParams] = useSearchParams();

    const customerId = searchParams.get('customerId');
    const orderId = searchParams.get('orderId');

    const redirectUrl = `/kunden/${customerId}/bestellungen/${orderId}`;

    return <Navigate to={redirectUrl} replace />;
};

OrderDetailsOld.isProtected = true;
OrderDetailsOld.permissions = [];

export default OrderDetailsOld;
